<nav class="navbar navbar-expand-lg navbar-dark">
    <a class="navbar-brand" routerLink="inicio">
        <img src="assets/img/Logo.png" width="40.64" alt="Parlamento Centroamericano" loading="lazy">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
                <a class="nav-link" routerLink="/inicio" routerLinkActive="text-active">Inicio</a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" routerLink="/noticias" routerLinkActive="text-active">Noticias</a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" routerLink="/agenda" routerLinkActive="text-active">Agenda</a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" routerLink="/documentos-plenaria" routerLinkActive="text-active">
                    Documentos plenaria
                </a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" routerLink="/parlacen-tv" routerLinkActive="text-active">Parlacen TV</a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" routerLink="/diputados" routerLinkActive="text-active">Diputados</a>
            </li>
          <!--   <li class="nav-item active">
                <a class="nav-link" routerLink="/usuarios" routerLinkActive="text-active">Usuarios</a>
            </li> -->
        </ul>
    </div>
</nav>
